import React, { Component } from 'react';
import FullWindowWrapper from 'components/shared/FullWindowWrapper/FullWindowWrapper';
import PreCommissionStepper from 'components/features/Commissioning/PreCommissionStepper/PreCommissionStepper';
import {
  getDeviceSwVersion,
  getNumericArraySwVersion,
  getNumericTrimmedSwVersion,
  swVersionCompare
} from 'common/utils/helpers';
import { IconAndText } from 'components/shared/SvgAF/SvgAF';
import { withAuth } from 'components/shared/Auth';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import { appConfig } from 'config';
import './CommissionWidget.css';
import { IconLoader } from 'common/IconLoader';

class CommissionWidget extends Component {
  state = {
    isPreCommissionFrameOpen: false,
    isCommissionFrameOpen: false,
    suDevices: null,
    siteId: null
  };

  launchCommission = () => {
    //attempt to renew session`
    this.props.auth
      .renewSession()
      .then(() => {
        this.setState({ isPreCommissionFrameOpen: true });
      })
      .catch(() => {
        this.props.history.push('/login');
      });
  };

  render() {
    let suDevicesString = '';
    let siteIdString = '';

    if (this.state.siteId != null) siteIdString = this.state.siteId;
    if (this.state.suDevices != null)
      this.state.suDevices.forEach((su, index) => (suDevicesString += '&suId' + (index + 1) + '=' + su));

    const softwareVersion = 'v' + getNumericTrimmedSwVersion(this.props.device);

    let isCommissionEnabled =
      this.props.device != null &&
      this.props.device.connectionState === 'Connected' &&
      this.props.supportedSoftwareVersions &&
      this.props.supportedSoftwareVersions.length > 0 && //this.props.supportedSoftwareVersions.find(sw => sw === softwareVersion);
      this.props.supportedSoftwareVersions.find(
        (v) =>
          swVersionCompare(
            getNumericArraySwVersion(getDeviceSwVersion(this.props.device)),
            getNumericArraySwVersion(v.substring(1))
          ) === 0
      ) &&
      this.props.permissions.includes('bm_read') &&
      this.props.permissions.includes('bm_create');

    let commissioningLink =
      this.props.device && this.props.device.id != null
        ? appConfig.commissioningBaseUrl +
          '/' +
          softwareVersion +
          '/?' +
          'ibmsInitiated' +
          '&siteId=' +
          siteIdString +
          '&deviceId=' +
          this.props.device.id +
          suDevicesString +
          '&userToken=' +
          this.props.auth.accessToken
        : null;

    // console.log("iframeURL",commissioningLink);

    //isCommissionEnabled = true;

    return (
      <div>
        <div
          className={isCommissionEnabled ? 'commissioningButton' : 'commissioningButton_disabled'}
          onClick={isCommissionEnabled ? () => this.launchCommission() : null}
        >
          <IconAndText
            img={isCommissionEnabled ? IconLoader.icon_commission : IconLoader.icon_commission_disabled}
            hoverImg={isCommissionEnabled ? IconLoader.icon_commission_hover : IconLoader.icon_commission_disabled}
            text={'Commission'}
          />
        </div>
        {this.state.isPreCommissionFrameOpen && (
          <FullWindowWrapper
            sendClose={() => {
              this.setState({ isCommissionFrameOpen: false });
              this.setState({ isPreCommissionFrameOpen: false });
            }}
          >
            {!this.state.isCommissionFrameOpen && (
              <PreCommissionStepper
                device={this.props.device}
                sendPreCommissioningCompleteDevices={(suDevices) => {
                  this.setState({ suDevices: suDevices });
                  this.setState({ isCommissionFrameOpen: true });
                }}
                sendPreCommissioningCompleteSite={(siteId) => {
                  this.setState({ siteId: siteId });
                }}
              />
            )}
            {this.state.isCommissionFrameOpen && (
              <iframe title="commissioningIframe" src={commissioningLink} frameBorder="0"></iframe>
            )}
          </FullWindowWrapper>
        )}
      </div>
    );
  }
}

export default withAuth(withRouter(
  connect((store) => {
    return {
      supportedSoftwareVersions: store.data.remoteCommissioning?.supportedWebsiteVersions,
      permissions: store.data.rolePermissions.permissions
    };
  })(CommissionWidget)
));
